import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { PaymentSearchResponse } from '../types/payment.types';
import { ENV } from '@app/constants/env';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.PAYMENTS_APIURL,
});

export interface ApiResponse<T> {
  success: boolean
  message?: string
  data?: T
  error?: string
}

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: rawBaseQuery,
  tagTypes: ['payment'],
  endpoints: (builder) => ({

    searchReferenceNumber: builder.query<ApiResponse<PaymentSearchResponse>, string>({
      query: (referenceNumber) => ({
        url: `MakePayment/SearchReferenceNo/${encodeURIComponent(referenceNumber)}`,
        method: 'GET',
      }),
      providesTags: ['payment'],
    }),

  }),
});

export const { 
  useSearchReferenceNumberQuery,
} = paymentApi;

export const submitPaymentToGateway = (paymentData: PaymentSearchResponse): void => {
  // Create a temporary form and submit it to the payment gateway
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = 'https://payments.epdq.co.uk/ncol/prod/orderstandard.asp';
  form.style.display = 'none';

  // Convert amount to the format expected by the payment gateway (multiply by 100 for cents)
  const amountInCents = Math.round(paymentData.amount * 100).toString();

  // Map the API response to payment gateway fields
  const fields = [
    { name: 'AMOUNT', value: amountInCents },
    { name: 'CURRENCY', value: paymentData.currency },
    { name: 'LANGUAGE', value: 'en_US' }, // Default language
    { name: 'LOGO', value: '' }, // Can be configured if needed
    { name: 'ORDERID', value: paymentData.orderNumber || paymentData.payID },
    { name: 'PSPID', value: 'YourPSPID' }, // This should be configured with actual PSPID
    { name: 'SHASIGN', value: 'generated_sha_signature' }, // This should be generated server-side
    { name: 'EMAIL', value: paymentData.ref1 }, // ref1 contains email
    { name: 'COM', value: `Payment for Invoice ${paymentData.invoiceno}` },
  ];

  fields.forEach(field => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = field.name;
    input.value = field.value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};